<div class="card chat-container">
  <!-- Chat Header -->
  <div class="card-header bg-primary text-white d-flex justify-content-between" appSafeArea id="myverticalNav" >
    <h3  style="color: white !important;">
      <i class="fa-solid fa-wand-magic-sparkles u-sidebar-nav-menu__item-icon text-white" style="font-size: 27px; color: white !important;"></i> 
      <span style="font-size: 27px; color: white !important;">
        {{'ai_assistance' | translate}}
      </span>
    </h3>
    
    <i class="pi pi-bars pt-2" (click)="sidebarVisible = true" style="font-size: 27px; color: white !important;"></i>
  </div>

  <!-- Chat Messages -->
  <div class="card-body chat-body">
    <div *ngFor="let message of messageHistory" class="mb-3">
      <div [ngClass]="{ 'text-end': message.role === 'user', 'text-start': message.role === 'system' }">
        <div
          [ngClass]="{
            'bg-light text-dark p-4 rounded-2 shadow-sm': message.role === 'system',
            'bg-primary text-white px-3 pt-2 rounded-3 shadow-sm': message.role === 'user'
          }"
          style="max-width: 75%; display: inline-block;"
        >
          <markdown *ngIf="message.role=='system'">
            {{ message.message }}
          </markdown>
          <p *ngIf="message.role=='user'">
            {{ message.message }}
          </p>
        </div>
      </div>
    </div>
  
    <!-- Skeleton Loader when loading -->
    <div *ngIf="loading" class="mb-3">
      <div class="text-start">
        <div class="skeleton-loader bg-light p-4 rounded-2 shadow-sm" style="max-width: 75%; display: inline-block;">
          <div class="skeleton-text"></div>
          <div class="skeleton-text short"></div>
        </div>
      </div>
    </div>
  </div>
  

  <!-- Chat Input (Fixed at Bottom) -->
  <div class="card-footer chat-footer p-2 pb-6">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="w-100 d-flex align-items-center">
      <div class="input-group chat-input-group">
        <input
          formControlName="prompt"
          type="text"
          class="form-control chat-input"
          [placeholder]="'CHAT.PLACEHOLDER' | translate"
        />
        <button class="btn chat-send-btn" type="submit" [disabled]="loading">
          <i class="fa-solid fa-paper-plane"></i>
        </button>
      </div>
    </form>
  </div>
  
</div>



 <p-drawer [(visible)]="sidebarVisible">
  <div class="text-center">
    <img src="../../../assets/images/DumyUser/touch.png" alt="" style="height: 60px" class="mb-2" />
  </div>

  <div class="navbar-vertical-content" style="background-color: white !important;" *ngIf="userRole!='Administrator'">
    <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/ManueDash')" routerLink="/ManueDash">
          <div class="d-flex justify-content-between">
            <i class="pi pi-objects-column u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'manue' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      
      
      <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/touchConnect')" routerLink="/touchConnect">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-bars u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'links' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li> -->
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/UserInterestManu')" routerLink="/UserInterestManu">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-magnet u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userInterests' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/userContacts')" routerLink="/userContacts">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-address-book u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userContacts' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
     
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/bussinessLeadPage')" routerLink="/bussinessLeadPage">
          <div class="d-flex justify-content-between">
            <i class="fas fa-briefcase u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessLeads' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/BusinessInsights')" routerLink="/BusinessInsights">
          <div class="d-flex justify-content-between">
            <i class="fas fa-chart-line u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessInsights' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/EconomicAssistance')" routerLink="/EconomicAssistance">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-wand-magic-sparkles u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'aiAssistance' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/EconimicNews')" routerLink="/EconimicNews">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-shekel-sign u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark "> {{'MENU.ECONOMIC_NEWS' | translate}}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
     
      
      <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navSetting">
        <a [ngClass]="getClassForRoute('/setting')" routerLink="/setting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-gear u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'setting' | translate }}</span>
            <i class="pt-1 text-white"></i>
          </div>
        </a>
      </li>
       -->
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/NotificationSettingsManue')" routerLink="/NotificationSettingsManue">
          <div class="d-flex justify-content-between">
            <i class="pi pi-cog text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'notificationAlerts' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
     
     
  
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/AccountSetting')" routerLink="/AccountSetting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Account Setting' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/DeleteMyAccount')" routerLink="/DeleteMyAccount">
          <div class="d-flex justify-content-between">
            <i class="pi pi-trash text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'DeleteMyAccount' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
     
      <li class="nav-item u-sidebar-nav-menu__item d-grid" id="navProfile">
        <a class="btn btn-primary mt-2 " (click)="logut()">
          <div class="d-flex justify-content-between">
            <i class="bi bi-box-arrow-left u-sidebar-nav-menu__item-icon text-white" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title pt-2">{{ 'Logout' | translate }}</span>
          </div>
        </a>
      </li>
      

    </div>
  </div>
  <div class="navbar-vertical-content" style="color: #000 !important; background-color: white !important;" *ngIf="userRole=='Administrator'">
    <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/ManueDash')" routerLink="/ManueDash">
          <div class="d-flex justify-content-between">
            <i class="pi pi-objects-column u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'manue' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/Admin')" routerLink="/Admin">
          <div class="d-flex justify-content-between">
            <i class="pi pi-microsoft u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'dashboard' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/touchConnect')" routerLink="/touchConnect">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-bars u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'links' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li> -->
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/UserInterestManu')" routerLink="/UserInterestManu">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-magnet u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userInterests' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/userContacts')" routerLink="/userContacts">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-address-book u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userContacts' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
     
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/bussinessLeadPage')" routerLink="/bussinessLeadPage">
          <div class="d-flex justify-content-between">
            <i class="fas fa-briefcase u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessLeads' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/BusinessInsights')" routerLink="/BusinessInsights">
          <div class="d-flex justify-content-between">
            <i class="fas fa-chart-line u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessInsights' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/EconomicAssistance')" routerLink="/EconomicAssistance">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-wand-magic-sparkles u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'aiAssistance' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/EconimicNews')" routerLink="/EconimicNews">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-shekel-sign u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark "> {{'MENU.ECONOMIC_NEWS' | translate}}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
     
      
      <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navSetting">
        <a [ngClass]="getClassForRoute('/setting')" routerLink="/setting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-gear u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'setting' | translate }}</span>
            <i class="pt-1 text-white"></i>
          </div>
        </a>
      </li>
       -->
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/NotificationSettingsManue')" routerLink="/NotificationSettingsManue">
          <div class="d-flex justify-content-between">
            <i class="pi pi-cog text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'notificationAlerts' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
     
     
  
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/AccountSetting')" routerLink="/AccountSetting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Account Setting' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/DeleteMyAccount')" routerLink="/DeleteMyAccount">
          <div class="d-flex justify-content-between">
            <i class="pi pi-trash text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'DeleteMyAccount' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/sitesetting')" routerLink="/sitesetting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Menu Admin' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      <li class="nav-item u-sidebar-nav-menu__item d-grid" id="navProfile">
        <a class="btn btn-primary mt-2 " (click)="logut()">
          <div class="d-flex justify-content-between">
            <i class="bi bi-box-arrow-left u-sidebar-nav-menu__item-icon text-white" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title pt-2">{{ 'Logout' | translate }}</span>
          </div>
        </a>
      </li>
      

    </div>
  </div>
</p-drawer>


